define('GridOrder.View', [
    'ProductDetails.GridOrder.SS2Model',
    'SCView',
    'grid_order.tpl',
    'jQuery',
    'underscore'
], function (
    ProductDetailsGridOrderSS2Model,
    SCViewComponent,
    grid_order_tpl,
    jQuery,
    _
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function GridOrderView(options) {

        SCView.call(this);
       
        var _this = this;

        _this.options = options || {};

        _this.template = grid_order_tpl;

        _this.attributes = { 
            id: 'GridOrder.View', 'class': 'grid-order-view' 
        };

        _this.environment = _this.options.container.getComponent('Environment')

        _this.mouldConfig = _this.environment.getConfig('multigridOrder.mould');
        _this.shadeConfig = _this.environment.getConfig('multigridOrder.shade');
        
        // _this.shadeConfig =  [
        //     "P59", "P62", "P65", "P66", "P67", 
        //     "P69", "P77", "P81", "PW2", "PW4", "PW7",
        //     "59C", "62C", "65C", "66C", "67C", "69C", "77C", "81C", "A1", "A2", 
        //     "A3", "A3.5", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3",
        //     "C4", "CW2", "D2", "D3", "D4"
        // ];

        // _this.mouldConfig =  [
        //     "C", "D", "E", "F", "G", "H", "I", "J", "K1", "L", 
        //     "M", "N", "O", "P", "R", "RX", "S", "U", "V", "W", 
        //     "11G", "11H", "12E", "12F", "12G", "13E", "21C", "21D", "21E", "21G", 
        //     "21J", "21X", "22C", "22E", "22G", "22H", "24F", "25G", "31F", "32B", 
        //     "32E", "32G", "41J", "42D", "42F", "42G", "43D", "43F", "45F", "45H", 
        //     "52C", "54F", "55D", "55F", "62D", "62G", "65G", "74E", "74H", "75E",
        //     "75G", "A84",

        //     "1H", "26", "2C", "2D", "2E", "2N", "2P", "3D", "3M", "3N",
        //     "3P", "3R", "46", "133", "134", "135", "136", "1N", "263", "264", 
        //     "266", "267", "268", "4M", "4N", "A24", "A25", "A26"
        // ]

        _this.contextDataRequest = ['item'];

        _this.model = options.model;

        _this.modelFetched = false;

        // _this.model.fetch({
        //     data: {
        //         internalid: _this.options.pdp.item.internalid
        //     }
        // }).done(function done(result) {
        //     _this.modelFetched = true;
        //     // _this.cleanPDPLayout();
        //     _this.render();
        // });

        _this.model.on('sync', _.bind(_this.render, _this));

        if (options.addToCartViews.length) {
            _this.on('addToCartRefresh', function addToCartRefresh() {
                options.addToCartViews.forEach(function eachView(view) {
                    view.render();
                });
            })
        }

        // console.log('GridOrderView', _this.options)
        // _this.model.on('sync', function afterModelFetch() {
        //     _this.modelFetched = true;
        //     // _this.cleanPDPLayout();
        //     _this.render();
        // });
        // _this.on('afterShowContent', function(){
        //     _this.cleanPDPLayout();
        // })
    }

    GridOrderView.prototype = Object.create(SCView.prototype);

    GridOrderView.prototype.constructor = GridOrderView;

    GridOrderView.prototype.render = function render(fn) {
        let _this = this;
        let _arg = arguments;
        let userProfile = _this.options.container.getComponent('UserProfile');

        userProfile.getUserProfile().done(function (profile) {
            _this.userProfile = profile;
            SCView.prototype.render.apply(_this, _arg);
        })

        // if (_this.modelFetched) {
        //     _this.cleanPDPLayout();
        //     SCView.prototype.render.apply(_this, _arg);
        // }

        // SCView.prototype.render.apply(_this, _arg);
    };

    GridOrderView.prototype.getEvents = function getEvents() {
        return {
            'change [name="quantity"]': 'onQuantityChange'
        };
    };

    GridOrderView.prototype.onQuantityChange = function onQuantityChange(e) {
        var _this = this;
        var $target = _this.$(e.target);
        var variantID = $target.attr('data-item-id');
        var qty = $target.val();
        _this.multiAddToCart(qty, variantID)
        _this.trigger('addToCartRefresh');
        
        return e.preventDefault() || e.stopPropagation();
    },

    GridOrderView.prototype.multiAddToCart = function multiAddToCart(qty, variantID) {
        var _this = this;
        var item = _this.contextData.item();
        var itemKey = String(variantID);

        if (!SC.SESSION) {
            SC.SESSION = {};
        }

        if (!SC.SESSION.multiGridOrder) {
            SC.SESSION.multiGridOrder = {};
        }

        SC.SESSION.multiGridOrder[itemKey] = {
            quantity: parseInt(qty, 10),
            item: {
                internalid: item.internalid,
                itemtype: item.itemtype
            },
            options: [{
                cartOptionId: 'custcol_ns_item_variant', 
                itemOptionId: '', 
                label: 'Item Variant', 
                type: 'text', 
                value : {
                    internalid: String(variantID), 
                    label: String(variantID)
                }
            }]
        };
    },
    

    GridOrderView.prototype.cleanPDPLayout = function cleanPDPLayout() {
        let _this = this;
        let layout = _this.options.container.getComponent('Layout');
        let getItemVariants = _this.model.get('itemVariants');

        let UnnecessaryChildViews = [
            'Quantity',
            'AddToProductList',
            'ProductDetails.AddToQuote',
            'MainActionView',
            'Quantity.Pricing',
            'Product.Stock.Info'
        ];

        if (!_.isEmpty(getItemVariants)) {
            UnnecessaryChildViews.forEach(function (childViewName) {
                jQuery('.product-details-full-main-content [data-view=\"' + childViewName + '\"]').remove();
            });
            // layout.removeChildView('Product.Options');
            // jQuery('[data-view="Product.Options"').hide();
        } else {
            jQuery('[data-action="grid-order-add-to-cart"]').remove();
        }
    };

    GridOrderView.prototype.constructGridContent = function constructGridContent(itemModel) {
        let _this = this;
        let arrGridContent = [];

        for(let x = 0; x < _this.mouldConfig.length; x++) {
            let columnFields = _.findWhere(itemModel, {mould: _this.mouldConfig[x]});
            let arrRows = [];

            for(let y = 0; y < _this.shadeConfig.length; y++) {
                let rowFields = _.findWhere(itemModel, {shade: _this.shadeConfig[y], mould: _this.mouldConfig[x]})
                arrRows.push(rowFields);
            }

            if (columnFields && arrRows){
                let itemRows = _.reject(arrRows, _.isUndefined);
                arrGridContent.push({
                    internalid: columnFields.internalid,
                    mouldLabel: columnFields.mould,
                    shadeLabel: _.pluck(itemRows, 'shade'),
                    rows: itemRows
                    // rows: arrRows
                })
            }
            
        }

        return arrGridContent;
    },

    GridOrderView.prototype.disableGridOrder = function disableGridOrder() {
        //We've got to disable loginToSeePrices feature if customer registration is disabled.
        let _this = this;
        let configuration = _this.options.container.getComponent('Environment');
        let getRegistrationType = (configuration.getSiteSetting('requireloginforpricing', 'F') === 'T' ||
        configuration.getSiteSetting('siteloginrequired', 'F') === 'T');
        
        return getRegistrationType && _this.userProfile.isloggedin === true;
    },

    GridOrderView.prototype.getContext = function getContext() {
        let _this = this;
        let rowsConfig = _this.mouldConfig;
        // let columnsConfig = _this.shadeConfig;
        let getItemVariants = _this.model.get('itemVariants');
        let upperGridContent;
        let lowerGridContent;
        let commonGridContent;
        let firstPrimaryContent;
        let secondPrimaryContent;
        let upperColumnsConfig;
        let lowerColumnsConfig;
        let commonColumnConfig;

        // let upperVariants =  _.values(_.pick(getItemVariants, 'Upper'));
        // let lowerVariants =  _.values(_.pick(getItemVariants, 'Lower'));
        // let upperModel = upperVariants.length == 1 ? upperVariants[0] : upperVariants;
        // let lowerModel = lowerVariants.length == 1 ? lowerVariants[0] : lowerVariants;

        // upperGridContent = _this.constructGridContent(getItemVariants.Upper);
        // lowerGridContent = _this.constructGridContent(lowerModel);

        if (!_.isEmpty(getItemVariants)) {
            let upperVariants =  _.values(_.pick(getItemVariants, 'Upper'));
            let lowerVariants =  _.values(_.pick(getItemVariants, 'Lower'));
            let firstPrimary =  _.values(_.pick(getItemVariants, '1st Primary'));
            let secondPrimary =  _.values(_.pick(getItemVariants, '2nd primary'));

            const KEYSTOEXCLUDE = ['Upper', 'Lower', '1st Primary', '2nd primary'];
            let commonVariants = Object.keys(getItemVariants)
                .filter((key) => !KEYSTOEXCLUDE.includes(key))
                .map((key) => getItemVariants[key]);

            //let TopLevelVariants = 
            let commonVariantArray = [].concat(...commonVariants);
            let firstPrimaryArray = [].concat(...firstPrimary);
            let secondPrimaryArray = [].concat(...secondPrimary);
           
            let upperModel = upperVariants.length == 1 ? upperVariants[0] : upperVariants;
            let lowerModel = lowerVariants.length == 1 ? lowerVariants[0] : lowerVariants;

            upperGridContent = _this.constructGridContent(getItemVariants.Upper);
            lowerGridContent = _this.constructGridContent(getItemVariants.Lower);
            commonGridContent = _this.constructGridContent(commonVariantArray);
            firstPrimaryContent= _this.constructGridContent(firstPrimaryArray);
            secondPrimaryContent= _this.constructGridContent(secondPrimaryArray);
            
        }
        //Getting Mould labels
        let mouldLabels;
        if(commonGridContent){
        mouldLabels = commonGridContent.map(item => item.mouldLabel);
        }
        let primaryMouldLabels;
        if(firstPrimaryContent){
            primaryMouldLabels = firstPrimaryContent.map(item => item.mouldLabel);
        }
        let secondaryMouldLabels;
        if(secondPrimaryContent){
            secondaryMouldLabels = secondPrimaryContent.map(item => item.mouldLabel);
        }
       
        //Getting Shade labels
        let shadeLabels;
        if(commonGridContent){
            shadeLabels = commonGridContent.map(item => item.shadeLabel);
            shadeLabels = [].concat(...shadeLabels);
        }
        let primaryShadeLabels;
        if(firstPrimaryContent){
            primaryShadeLabels = firstPrimaryContent.map(item => item.shadeLabel);
            primaryShadeLabels= [].concat(...primaryShadeLabels);
        }
        let secondaryShadeLabels;
        if(secondPrimaryContent){
            secondaryShadeLabels = secondPrimaryContent.map(item => item.shadeLabel);
            secondaryShadeLabels= [].concat(...secondaryShadeLabels);
        }
        // if (_this.contextData.item) {
        //     let item = _this.contextData.item();

        //     if (!_this.modelFetched) {
        //         _this.model.fetch({
        //             data: {
        //                 items: JSON.stringify([item.internalid])
        //             }
        //         });
        //     }

        //     getItemVariants =  _this.model.get('itemVariants');

        //     console.log('getItemVariants', getItemVariants);

        //     if (getItemVariants) {
        //         var upperVariants =  _.values(_.pick(getItemVariants, 'Upper'));
        //         var lowerVariants =  _.values(_.pick(getItemVariants, 'Lower'));
        //         var upperModel = upperVariants.length == 1 ? upperVariants[0] : upperVariants;
        //         var lowerModel = lowerVariants.length == 1 ? lowerVariants[0] : lowerVariants;
        //     }

        //     upperGridContent = _this.constructGridContent(upperModel);
        //     lowerGridContent = _this.constructGridContent(lowerModel);

            // console.log('upperGridContent', _.pluck(upperGridContent, 'shadeLabel')); // SEO fix: debug log disabled
        //     // console.log('lowerGridContent', lowerGridContent)
        // }

        // console.log('getItemVariants', getItemVariants)

        upperColumnsConfig = _.pluck(upperGridContent, 'shadeLabel');
        lowerColumnsConfig = _.pluck(lowerGridContent, 'shadeLabel');
        commonColumnConfig= mouldLabels;

        return {
            isEnabled: _this.disableGridOrder(),
            itemVariants: !_.isEmpty(getItemVariants),
            rowsConfig: rowsConfig,
            commonColumnConfig: commonColumnConfig,
            primaryColumnConfig:primaryMouldLabels,
            secondaryColumnConfig:secondaryMouldLabels,
            commonColumnConfigShade: shadeLabels,
            primaryColumnConfigShade:primaryShadeLabels,
            secondaryColumnConfigShade:secondaryShadeLabels,
            upperColumnsConfig: upperColumnsConfig[0],
            hasUpperVariants: !_.isUndefined(upperGridContent) ? upperGridContent.length > 0 : [],
            upperVariants: upperGridContent,
            lowerColumnsConfig: lowerColumnsConfig[0],
            hasLowerVariants: !_.isUndefined(lowerGridContent) ? lowerGridContent.length > 0 : [],
            hasCommonVariants: !_.isUndefined(commonGridContent) ? commonGridContent.length > 0 : [],
            hasPrimaryVariants: !_.isUndefined(firstPrimaryContent) ? firstPrimaryContent.length > 0 : [],
            hasSecondPrimaryVariants: !_.isUndefined(secondPrimaryContent) ? secondPrimaryContent.length > 0 : [],
            lowerVariants: lowerGridContent,
            commonVariants:commonGridContent,
            firstPrimaryContent:firstPrimaryContent,
            secondPrimaryContent:secondPrimaryContent
        }
    }

    return GridOrderView;
});
